<template>
    <div class="assistsWrap" id="assistsWrap">
        <div class="assistsDatawrap">
            <p class="tableTit" v-if="!noDataModeShow">
                <span class="assistState1"> </span>
                <span :class="'assistState'+(index+2)" v-for="(item,index) in assistsData.header">{{item}}</span>
            </p>
            <div class="tableBody">
                <div class="list" v-for="(item,index) in assistsData.data"><span
                    class="assistState1">{{index+1}}</span>
                    <span class="assistState2">
                    <img class="avarta assist_avarta"
                         :data-src="getImgSrc(item.person_logo)"
                         src="//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png"
                         alt=""
                         onerror="javascript:this.src='//img-sd.allfootballapp.com/fastdfs3/M00/B5/98/ChOxM1xC37CADGDCAAANHjH55fo314.png'"
                    >
                    {{item.person_name}}
                </span>
                    <span class="assistState3">{{item.team_name}}</span><span class="assistState4">{{item.count}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: '',
        data: function () {
            return {};
        },
        created: function () {
        },
        method: {},
        props: ['assistsData', 'noDataModeShow'],
    };
</script>
<style lang="less">
    .assistsWrap {
        height: auto;
        overflow: hidden;
    }

    .assistsWrap .tableTit {
        height: 1.8rem;
        background: #404c57;
        color: #fff;
        line-height: 1.8rem;
        font-size: .68rem;
    }

    .assistsWrap .tableTit span, .assistsWrap .list span {
        display: inline-block;
        /*text-align: left;*/
    }

    .assistsWrap .assistState1 {
        margin-left: .1rem;
        width: 2.4rem;
        text-align: center;
    }

    .assistsWrap .assistState2 {
        width: 8rem;
        margin-right: .5rem;
    }

    .assistsWrap .assistState3 {
        width: 8rem;
        margin-right: .5rem;
    }

    .assistsWrap .assistState4 {
        width: 2.5rem;
        text-align: center;
    }

    .assistsWrap .tableBody {
        background: #333d46;
    }

    .assistsWrap .tableTit .assistState2 {
        position: relative;
        left: 0.2rem;
    }

    .assistsWrap .list {
        font-size: .68rem;
        height: 2.8rem;
        line-height: 2.8rem;
        color: #fff;
        border-bottom: 1px solid #2b353d;
    }

    .assistsWrap .list span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .assistsWrap .list .avarta {
        width: 1.5rem;
        height: 1.5rem;
        overflow: hidden;
        border-radius: 50%;
        vertical-align: middle;
        margin-right: .5rem;
        position: relative;
    }

    .assistsWrap .list .assistState1 {
        position: relative;
        top: 0.01rem;
        font-size: 0.68rem;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// assists.vue?fb216fb4